"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityMandateDetailsEntry = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const mstr_activity_entity_1 = require("./mstr-activity.entity");
const company_entity_1 = require("./company.entity");
const look_up_entity_1 = require("./look-up.entity");
const opportunity_mandate_details_contact_map_entity_1 = require("./opportunity-mandate-details-contact-map.entity");
const opportunity_mandate_details_document_map_entity_1 = require("./opportunity-mandate-details-document-map.entity");
let OpportunityMandateDetailsEntry = class OpportunityMandateDetailsEntry {
    constructor(id, opportunityId, activityId, companyId, activityDate, planDate, mandateTypeLid, validFrom, validTo, compensationPayable, compensationTypeLid, issuedOn, remarks, statusLid, createdAt, updatedAt, createdBy, updatedBy) {
        this.id = id;
        this.opportunityId = opportunityId;
        this.activityId = activityId;
        this.companyId = companyId;
        this.activityDate = activityDate;
        this.planDate = planDate;
        this.mandateTypeLid = mandateTypeLid;
        this.validFrom = validFrom;
        this.validTo = validTo;
        this.compensationPayable = compensationPayable;
        this.compensationTypeLid = compensationTypeLid;
        this.issuedOn = issuedOn;
        this.remarks = remarks;
        this.statusLid = statusLid;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.OpportunityMandateDetailsEntry = OpportunityMandateDetailsEntry;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "activity_date",
        type: "date",
        default: () => "CURRENT_DATE",
    }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], OpportunityMandateDetailsEntry.prototype, "activityDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "plan_date", type: "date" }),
    tslib_1.__metadata("design:type", typeof (_j = typeof Date !== "undefined" && Date) === "function" ? _j : Object)
], OpportunityMandateDetailsEntry.prototype, "planDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mandate_type_lid" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "mandateTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "valid_from", type: "date" }),
    tslib_1.__metadata("design:type", typeof (_k = typeof Date !== "undefined" && Date) === "function" ? _k : Object)
], OpportunityMandateDetailsEntry.prototype, "validFrom", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "valid_to", type: "date" }),
    tslib_1.__metadata("design:type", typeof (_l = typeof Date !== "undefined" && Date) === "function" ? _l : Object)
], OpportunityMandateDetailsEntry.prototype, "validTo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "compensation_payable", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "compensationPayable", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "compensation_type_lid" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "compensationTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "issued_on", type: "date" }),
    tslib_1.__metadata("design:type", typeof (_m = typeof Date !== "undefined" && Date) === "function" ? _m : Object)
], OpportunityMandateDetailsEntry.prototype, "issuedOn", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityMandateDetailsEntry.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamp" }),
    tslib_1.__metadata("design:type", typeof (_o = typeof Date !== "undefined" && Date) === "function" ? _o : Object)
], OpportunityMandateDetailsEntry.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamp" }),
    tslib_1.__metadata("design:type", typeof (_p = typeof Date !== "undefined" && Date) === "function" ? _p : Object)
], OpportunityMandateDetailsEntry.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityMandateDetailsEntry.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_q = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _q : Object)
], OpportunityMandateDetailsEntry.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => mstr_activity_entity_1.MstrActivity),
    (0, typeorm_1.JoinColumn)({ name: "activity_id" }),
    tslib_1.__metadata("design:type", typeof (_r = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _r : Object)
], OpportunityMandateDetailsEntry.prototype, "activity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => company_entity_1.Company),
    (0, typeorm_1.JoinColumn)({ name: "company_id" }),
    tslib_1.__metadata("design:type", typeof (_s = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _s : Object)
], OpportunityMandateDetailsEntry.prototype, "company", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "mandate_type_lid" }),
    tslib_1.__metadata("design:type", typeof (_t = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _t : Object)
], OpportunityMandateDetailsEntry.prototype, "mandateType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "compensation_type_lid" }),
    tslib_1.__metadata("design:type", typeof (_u = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _u : Object)
], OpportunityMandateDetailsEntry.prototype, "compensationType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", typeof (_v = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _v : Object)
], OpportunityMandateDetailsEntry.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_mandate_details_contact_map_entity_1.OpportunityMandateDetailsContactMap, (contactMap) => contactMap.mandate, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityMandateDetailsEntry.prototype, "mandateDetailsContacts", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_mandate_details_document_map_entity_1.OpportunityMandateDetailsDocumentMap, (documentMap) => documentMap.mandate, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityMandateDetailsEntry.prototype, "mandateDetailsDocuments", void 0);
exports.OpportunityMandateDetailsEntry = OpportunityMandateDetailsEntry = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_mandate_details_entry"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, Number, typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object, typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object, Number, Number, typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object, String, Number, typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object, typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object, Number, Number])
], OpportunityMandateDetailsEntry);
